export function getUniquePropertyValues(array, property) {
	try {
		return [...new Set(array.map(item => item[property]))];
	} catch (e) {
		console.error('Error getting unique property values from array:', e);
		return undefined;
	}
}
